import getBlockGroups from "./output/getBlockGroups";

const isSpaced = blockGroup => (
  ["unordered-list-item", "ordered-list-item"].includes(blockGroup.type)
  && blockGroup.blocks[0].depth === 0
);

const getListPrefix = (type, index) => {
  switch (type) {
    case "unordered-list-item":
      return "* ";
    case "ordered-list-item":
      return `${index}. `;
    default:
      return "";
  }
};

const getBlockText = (blockGroup, block, index) => {
  const components = [
    " ".repeat(block.depth * 2),
    getListPrefix(blockGroup.type, index),
    block.text
  ];

  let lines = [components.join("")];
  if (block.childGroups) {
    // eslint-disable-next-line no-use-before-define, @typescript-eslint/no-use-before-define
    lines = lines.concat(block.childGroups.map(getBlockGroupText));
  }

  return lines.join("\n");
};

const getBlockGroupText = blockGroup => {
  if (blockGroup.type === "atomic") {
    return "";
  }

  const blockGroups = blockGroup.blocks.map((block, index) => (
    getBlockText(blockGroup, block, index + 1)
  ));

  if (isSpaced(blockGroup)) {
    blockGroups.unshift("");
    blockGroups.push("");
  }

  return blockGroups.join("\n");
};

const getText = output => {
  if (!output || !output.startsWith("{")) {
    return output;
  }

  const { blocks } = JSON.parse(output);
  return getBlockGroups(blocks).map(getBlockGroupText).join("\n");
};

export default getText;
